import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a60dwguc: FaireBrandEntity = {
  token: "b_a60dwguc",
  type: "brand",
  name: "Milkhouse Candle Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/132a3ce9d8cee295b610eb4edf2c0fed691642fd2033749a3f716a1cb4760d11.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/170e1a5f1beabf69c79105e3e91a33e689173428b83a3f7c915c19a4de4b0453.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/132a3ce9d8cee295b610eb4edf2c0fed691642fd2033749a3f716a1cb4760d11.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/170e1a5f1beabf69c79105e3e91a33e689173428b83a3f7c915c19a4de4b0453.jpeg",
  location: "St. Ansgar, IA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 782,
  isTopShop: true,
  isInsider: true,
  description:
    "Milkhouse Candle Company founders, Eric and Janet Sparrow, have strong ties to agricultural America. It's their Midwest upbringing that inspired the creation of a cleaner, healthier candle experience. \n\nStarting as a hobby for the couple in 2002, their candle making dates at the kitchen table began with canning jars they bought at local auctions. They shared their creations with friends, family, and co-workers, and suddenly they started getting more requests for candles.\n\nYears after the original candles were produced, Milkhouse Candles has grown into a thriving company that continues to produce fragrant soy and beeswax candles of the highest quality.\n\nThe Milkhouse blend of waxes is simple: pure beeswax and natural soy wax from soybeans grown in America’s Midwest. No artificial dyes are added and there is no lead in the wicks. Our blend of waxes provides a safe and clean-burning alternative to paraffin candles.\n\nIf you'd like to learn more about Milkhouse Candles and what it takes to become a Milkhouse Retailer, reach out to us or check us out at our full website, www.milkhousecandles.com.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:13.333Z",
    importedBy: "entity-db-cli",
  },
};
